import React from "react";
import { Row, Col } from "react-flexbox-grid";

// Components
// import TeamBox from './teamBox';
// import TeamInfo from "./teamInfo";
import Title from "../ui-components/title/title";
 import SkillBar from 'react-skillbars';
 import Button from "../ui-components/button/button";
const skillsDetail = [
  {type: "Java", level: 95},
  {type: "MySQL", level: 90},
  {type: "C++", level:85},
  {type: "C", level: 85},
  {type: "Python", level: 80},
  {type: "Git", level: 80},
  {type: "HTML", level: 70},
  {type: "CSS", level: 70},
  {type: "Javascript", level: 65},
];
const colors = {
  "bar": "#ffe600",
  "title": {
    "text": "#fff",
    "background": "#000000"
  }
}
const skills = () => (
  <div id="skills">
    <div className="wrapper">
      <Title title="SKILLS" />
     
        <SkillBar skills={skillsDetail} colors={colors} animationDelay={1000}/>
        
      <Row className="flex-center padding40">
            <Button label="FIND MY SKILLS USEFUL?" target={"contact"} />
          </Row>
    </div>
  </div>
);

export default skills;